<template>
  <svg
    width="6"
    height="14"
    viewBox="0 0 6 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="pause-play-svg counter-spin"
  >
    <line
      x1="0.5"
      y1="0.5"
      x2="0.499999"
      y2="13.5"
      stroke="black"
      stroke-linecap="round"
    />
    <line
      x1="5.5"
      y1="0.5"
      x2="5.5"
      y2="13.5"
      stroke="black"
      stroke-linecap="round"
    />
  </svg>
</template>
